import {useNavigate, Outlet} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useGetMeQuery} from "../slices/rootApiSlices/authApiSlice";
import {Col, Row} from "antd";
import {SyncOutlined} from "@ant-design/icons";
import {useEffect} from "react";
import {logout} from "../slices/authSlice";

const PrivateRoute = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {user} = useSelector((state) => state.auth);
    const {data, error, isLoading} = useGetMeQuery(user?.token, {
        refetchOnMount: false,
    });


    useEffect(() => {
        if (error || error?.data?.status === false) {
            dispatch(logout())
            navigate("/auth/sign-in");
        }
    }, [data, error, isLoading, dispatch, navigate]);

    if (isLoading) {
        return (
            <Row style={{textAlign: "center", justifyContent: "center"}}>
                <Col>
                    <SyncOutlined size="large" spin={true}/>
                </Col>
            </Row>
        );
    }

    return <Outlet/>;
};

export default PrivateRoute;
